import { render, staticRenderFns } from "./label.vue?vue&type=template&id=70793e0b&scoped=true&lang=pug&"
import script from "./label.vue?vue&type=script&lang=js&"
export * from "./label.vue?vue&type=script&lang=js&"
import style0 from "./label.vue?vue&type=style&index=0&id=70793e0b&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70793e0b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('70793e0b', component.options)
    } else {
      api.reload('70793e0b', component.options)
    }
    module.hot.accept("./label.vue?vue&type=template&id=70793e0b&scoped=true&lang=pug&", function () {
      api.rerender('70793e0b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/prop_panel/component/label.vue"
export default component.exports